/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_Resources_CountInputs */

const en_admin_analyze_allocations_resources_count = /** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const de_admin_analyze_allocations_resources_count = /** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen`)
};

const es_admin_analyze_allocations_resources_count = /** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const fr_admin_analyze_allocations_resources_count = /** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

/** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */
const it_admin_analyze_allocations_resources_count = en_admin_analyze_allocations_resources_count;

/** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_resources_count = en_admin_analyze_allocations_resources_count;

/** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */
const pl_admin_analyze_allocations_resources_count = en_admin_analyze_allocations_resources_count;

/** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */
const hu_admin_analyze_allocations_resources_count = en_admin_analyze_allocations_resources_count;

/** @type {(inputs: Admin_Analyze_Allocations_Resources_CountInputs) => LocalizedString} */
const ro_admin_analyze_allocations_resources_count = en_admin_analyze_allocations_resources_count;

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Admin_Analyze_Allocations_Resources_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_resources_count = /** @type {((inputs?: Admin_Analyze_Allocations_Resources_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_Resources_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_resources_count(inputs)
	if (locale === "de") return de_admin_analyze_allocations_resources_count(inputs)
	if (locale === "es") return es_admin_analyze_allocations_resources_count(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_resources_count(inputs)
	if (locale === "it") return it_admin_analyze_allocations_resources_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_resources_count(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_resources_count(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_resources_count(inputs)
	return ro_admin_analyze_allocations_resources_count(inputs)
});
export { admin_analyze_allocations_resources_count as "admin.analyze.allocations.resources_count" }